import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M10 8h4l-2 8","key":"svg-1"}]]

const IconSquareNumber7 = createReactComponent('outline', 'square-number-7', 'SquareNumber7', __iconNode);

export default IconSquareNumber7;